"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var debounce_1 = __importDefault(require("lodash/debounce"));
var get_1 = __importDefault(require("lodash/get"));
var api_wrapper_1 = require("../../api/api-wrapper");
var element_generator_1 = require("../../element-generator");
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var variables_const_1 = require("../../variables.const");
var Location = /** @class */ (function () {
    function Location() {
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.studios = [];
        this.filteredStudios = [];
        this.maxSearchResults = 5;
        this.maxShowedStudios = 3;
        this.stylesAdded = false;
        this.searchBarId = '#location-search';
        this.openStreetMapResults = '#search-results-wrapper';
    }
    Location.prototype.loadModule = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var _k, harcodededStudios_1, _loop_1, _i, _l, studio;
            var _this = this;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        this.addStyle();
                        _k = this;
                        return [4 /*yield*/, this.apiWrapper.getStudios()];
                    case 1:
                        _k.studios = _m.sent();
                        //Sometimes we have the studios hardcoded on the page and not generated through this module
                        //Therefore we have to adjust our internal arrays and enhance those hardcoded studio Dom elements with additional data
                        if ((_a = $('[data-location]')) === null || _a === void 0 ? void 0 : _a.length) {
                            harcodededStudios_1 = [];
                            _loop_1 = function (studio) {
                                $('[data-location]').each(function (i, el) {
                                    if (String(studio.id) === el.getAttribute('data-location')) {
                                        harcodededStudios_1.push(studio);
                                    }
                                });
                            };
                            for (_i = 0, _l = this.studios; _i < _l.length; _i++) {
                                studio = _l[_i];
                                _loop_1(studio);
                            }
                            this.studios = harcodededStudios_1;
                        }
                        //If studio list is filtered by default
                        if ((_c = (_b = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _b === void 0 ? void 0 : _b.filterStudioIds) === null || _c === void 0 ? void 0 : _c.length) {
                            this.studios = this.studios.filter(function (a) {
                                return variables_const_1._settings.location.filterStudioIds.some(function (b) { return b === a.id; });
                            });
                            this.filterStudiosByDistance();
                        }
                        //Hide studios by id
                        if ((_e = (_d = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _d === void 0 ? void 0 : _d.hideStudioIds) === null || _e === void 0 ? void 0 : _e.length) {
                            this.studios = this.studios.filter(function (a) {
                                return variables_const_1._settings.location.hideStudioIds.some(function (b) { return b !== a.id; });
                            });
                            this.filterStudiosByDistance();
                        }
                        this.filteredStudios = JSON.parse(JSON.stringify(this.studios));
                        if ((_f = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _f === void 0 ? void 0 : _f.initialStudioCount) {
                            this.maxShowedStudios = variables_const_1._settings.location.initialStudioCount;
                            this.filteredStudios = this.filteredStudios.slice(0, this.maxShowedStudios);
                            this.hideAndShowHardcodedStudioLocations();
                        }
                        if (!(((_g = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _g === void 0 ? void 0 : _g.userGpsTracking) === false)) {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(function (position) {
                                    _this.userLatitude = +position.coords.latitude;
                                    _this.userLongitude = +position.coords.longitude;
                                    _this.filterStudiosByDistance();
                                });
                            }
                            else {
                                console.log('Geolocation is not supported by this browser.');
                            }
                        }
                        //hide ref objects
                        [
                            (_h = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _h === void 0 ? void 0 : _h.searchResultRefObject,
                            (_j = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _j === void 0 ? void 0 : _j.showMoreRefObject,
                        ].forEach(function (a) { return $('#' + a).css('display', 'none'); });
                        if (variables_const_1.environment === 'dev') {
                            console.info('If you want to use directly the magicline studio object just define some parent object as [data-location="<<LOCATION-ID>>"]', 'And than you can use in the children e.g. custom attributes like [data-get="distanceToUser"]');
                        }
                        if ($(this.searchBarId).length) {
                            $(this.searchBarId).on('keydown', function (event) {
                                if (event.key === 'Enter' || event.keyCode === 13) {
                                    event.stopImmediatePropagation();
                                    event.preventDefault();
                                }
                            });
                            $(this.searchBarId).on('keyup', (0, debounce_1.default)(function (event) {
                                var search = event.target
                                    .value;
                                if (search.length > 3 && search !== _this.lastSearch) {
                                    _this.getUserLocationByInput(search);
                                }
                            }, 300));
                        }
                        else {
                            console.error('No location search bar found');
                        }
                        this.generateDefaultStudioList();
                        this.modifyDataGetObjects();
                        return [2 /*return*/];
                }
            });
        });
    };
    Location.prototype.getUserLocationByInput = function (input) {
        var _this = this;
        if ($(this.openStreetMapResults).length) {
            $(this.openStreetMapResults).html('');
            $(this.openStreetMapResults).append(this.helper.getLoader());
            this.lastSearch = input;
            var url = 'https://nominatim.openstreetmap.org/search?q=' +
                input +
                '&format=json&limit=' +
                this.maxSearchResults;
            fetch(url)
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, response.json()];
                        case 1:
                            data = _a.sent();
                            if (data.length > 0) {
                                this.generateUserLocationsList(data);
                            }
                            else {
                                this.helper.deleteLoadingScreen();
                            }
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (error) {
                console.log('An error occurred: ' + error);
                _this.helper.deleteLoadingScreen();
            });
        }
        else if (variables_const_1.environment === 'dev') {
            console.error('No wrapper for openstreetmap results please use id: ', this.openStreetMapResults);
        }
    };
    Location.prototype.generateUserLocationsList = function (locations) {
        var _this = this;
        var _a;
        var locationHTML = [];
        var _loop_2 = function (location_1) {
            var jqueryObject = void 0;
            if ((_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _a === void 0 ? void 0 : _a.searchResultRefObject) {
                jqueryObject = this_1.helper.createClonesForRefObjectId([], '#' + variables_const_1._settings.location.searchResultRefObject);
                jqueryObject.find('[data-get]').each(function (i, el) {
                    if (el.getAttribute('data-get') === 'display_name') {
                        el.innerHTML = location_1.display_name;
                    }
                });
            }
            else {
                var html = "<div style=\"display:flex;flex-direction:column\">\n        <strong>".concat(location_1.display_name, "</strong>\n        </div><div>Dein Ort</div>");
                jqueryObject = this_1.elementGenerator.getRow({
                    html: html,
                    class: 'search-result-picker',
                });
            }
            locationHTML.push(jqueryObject.on('click', function () {
                $(_this.openStreetMapResults).html('');
                _this.userLatitude = +location_1.lat;
                _this.userLongitude = +location_1.lon;
                _this.filterStudiosByDistance();
            }));
        };
        var this_1 = this;
        for (var _i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
            var location_1 = locations_1[_i];
            _loop_2(location_1);
        }
        $(this.openStreetMapResults).html('');
        $(this.openStreetMapResults).append(locationHTML);
        this.helper.deleteLoadingScreen();
    };
    Location.prototype.fireChangeEvent = function () {
        var locationChangedEvent = new CustomEvent('locationChanged', {
            detail: {
                filteredStudios: this.filteredStudios,
                studios: this.studios,
                latitude: this.userLatitude,
                longitude: this.userLongitude,
            },
        });
        document.dispatchEvent(locationChangedEvent);
    };
    Location.prototype.fireSelectionEvent = function (detail) {
        var selectionEvent = new CustomEvent('locationSelected', {
            detail: detail,
        });
        document.dispatchEvent(selectionEvent);
    };
    Location.prototype.filterStudiosByDistance = function () {
        var _this = this;
        if (this.userLatitude && this.userLongitude) {
            this.studios.forEach(function (a) {
                a.distanceToUser =
                    Math.round(_this.helper.earthDistance(+_this.userLatitude, +_this.userLongitude, +a.address.latitude, +a.address.longitude) * 10) / 10;
            });
        }
        this.filteredStudios = JSON.parse(JSON.stringify(this.studios));
        if (this.userLatitude && this.userLongitude) {
            this.filteredStudios = this.filteredStudios.sort(function (a, b) { return a.distanceToUser - b.distanceToUser; });
        }
        this.filteredStudios = this.filteredStudios.slice(0, this.maxShowedStudios);
        this.generateDefaultStudioList();
        this.modifyDataGetObjects();
        this.hideAndShowHardcodedStudioLocations();
        this.fireChangeEvent();
    };
    /**
     * Sometimes we have the studio dom objects hardcodeded on the page but want to mimic a search behaviour.
     */
    Location.prototype.hideAndShowHardcodedStudioLocations = function () {
        var _this = this;
        var _a;
        if ((_a = $('[data-location]')) === null || _a === void 0 ? void 0 : _a.length) {
            $('[data-location]').each(function (i, el) {
                var studioId = el.getAttribute('data-location');
                var studio = _this.filteredStudios.find(function (a) { return String(a.id) === studioId; });
                el.setAttribute('data-set', String(studio === null || studio === void 0 ? void 0 : studio.distanceToUser) || null);
                el.style.display = studio ? 'flex' : 'none';
            });
            this.reorderForExistingStudios();
            var showMoreButton = this.createShowMoreButton();
            if (showMoreButton) {
                $($('[data-location]')[$('[data-location]').length - 1]).after(showMoreButton);
            }
        }
    };
    Location.prototype.reorderForExistingStudios = function () {
        var _a;
        var locationObj = $('#' + ((_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _a === void 0 ? void 0 : _a.locationsWrapperId));
        if (locationObj.length) {
            this.filteredStudios.forEach(function (studio) {
                var studioId = String(studio.id);
                if ($('[data-location="' + studioId + '"]').length) {
                    locationObj.append($('[data-location="' + studioId + '"]')[0]);
                }
            });
        }
    };
    Location.prototype.createShowMoreButton = function () {
        var _this = this;
        var _a;
        if (this.maxShowedStudios < this.studios.length &&
            this.filteredStudios.length < this.studios.length) {
            $('.show-more-button').remove();
            var cloneObject = this.elementGenerator.getRow({
                html: 'MEHR ANZEIGEN',
                class: 'location-picker show-more-button show-more-button-css',
            });
            if ((_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _a === void 0 ? void 0 : _a.showMoreRefObject) {
                cloneObject = this.helper.createClonesForRefObjectId([{ key: 'class', value: 'show-more-button' }], '#' + variables_const_1._settings.location.showMoreRefObject);
            }
            return cloneObject.on('click', function () {
                _this.showMore();
            });
        }
        else {
            $('.show-more-button').remove();
        }
    };
    Location.prototype.generateDefaultStudioList = function () {
        var _this = this;
        var _a, _b, _c;
        if ($('#location-wrapper').length === 0) {
            console.error('NO LOCATION WRAPPER FOUND PLEASE ADD #location-wrapper for search results');
            return;
        }
        var studiosHtml = [];
        var _loop_3 = function (studio) {
            //default solid styling
            var innerHtml = "<div style=\"display:flex;flex-direction:column\">\n      <strong>".concat(studio.studioName, "</strong>\n      <span>").concat(studio.address.street, " ").concat(studio.address.houseNumber, ", ").concat(studio.address.zipCode, " ").concat(studio.address.city, "</span>\n      </div>\n      <div style=\"display:flex;flex-direction:column\">\n        <strong><i>Studio W\u00E4hlen</i></strong>\n        ").concat(studio.distanceToUser
                ? '<span>' + studio.distanceToUser + 'km</span>'
                : '', "\n      </div>");
            var html = this_2.elementGenerator.getRow({
                html: innerHtml,
                class: 'location-picker',
            });
            //overwrite default location object by refobjectid
            var refObjectId = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.refObjectId;
            if (((_a = studio === null || studio === void 0 ? void 0 : studio.studioTags) === null || _a === void 0 ? void 0 : _a.length) && Array.isArray(studio === null || studio === void 0 ? void 0 : studio.studioTags)) {
                // You can define different refobject id's for different studio types by simply adding them in the settings object
                var tagName = studio.studioTags[0].name;
                if ((_c = (_b = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _b === void 0 ? void 0 : _b.studioTags) === null || _c === void 0 ? void 0 : _c[tagName]) {
                    var tagObj = variables_const_1._settings.location.studioTags[tagName];
                    if (tagObj === null || tagObj === void 0 ? void 0 : tagObj.refObjectId) {
                        refObjectId = tagObj.refObjectId;
                    }
                    if (tagObj === null || tagObj === void 0 ? void 0 : tagObj.redirect) {
                        studio.redirect = tagObj.redirect;
                    }
                }
            }
            if ($('#' + refObjectId).length > 0) {
                //replace with helper function
                var copiedObject = this_2.helper.createClonesForRefObjectId([
                    { key: 'data-studio-id', value: String(studio.id) },
                    { key: 'data-studio-name', value: String(studio.studioName) },
                ], '#' + refObjectId, true);
                this_2.replaceDataAttributes(copiedObject, studio);
                copiedObject.css('display', 'flex');
                html = copiedObject;
            }
            else if (variables_const_1.environment === 'dev') {
                console.error('REF object not found', refObjectId, 'using default for ', studio);
            }
            studiosHtml.push(html.on('click', function (event) {
                var _a;
                localStorage.setItem('Location', String(studio.id));
                localStorage.setItem('studioId', String(studio.id));
                localStorage.setItem('StudioName', String(studio.studioName));
                localStorage.setItem('studioName', String(studio.studioName));
                if (studio === null || studio === void 0 ? void 0 : studio.tenantId) {
                    localStorage.setItem('TenantId', String(studio === null || studio === void 0 ? void 0 : studio.tenantId));
                    localStorage.setItem('tenantId', String(studio === null || studio === void 0 ? void 0 : studio.tenantId));
                }
                _this.fireSelectionEvent({
                    event: event,
                    element: html,
                    location: studio.id,
                    name: studio.studioName,
                });
                if ((studio === null || studio === void 0 ? void 0 : studio.redirect) || (variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.redirect)) {
                    window.location.href = (_a = studio.redirect) !== null && _a !== void 0 ? _a : variables_const_1._settings.redirect;
                }
            }));
        };
        var this_2 = this;
        for (var _i = 0, _d = this.filteredStudios; _i < _d.length; _i++) {
            var studio = _d[_i];
            _loop_3(studio);
        }
        var moreButton = this.createShowMoreButton();
        if (moreButton) {
            studiosHtml.push(moreButton);
        }
        $('#location-wrapper').html('');
        $('#location-wrapper').append(studiosHtml);
    };
    /**
     * Finds [data-location] objects on the page and allows to use [data-get] attributes on children
     */
    Location.prototype.modifyDataGetObjects = function () {
        var _this = this;
        var locations = $('[data-location]');
        if (locations.length) {
            locations.each(function (index, location) {
                var id = location.getAttribute('data-location');
                if (id === null || id === void 0 ? void 0 : id.length) {
                    var studio = _this.studios.find(function (studio) { return String(studio.id) === id; });
                    _this.replaceDataAttributes($(location), studio);
                }
            });
        }
    };
    Location.prototype.replaceDataAttributes = function (copiedObject, studio) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var childrenWithAttributes = copiedObject.find('[data-get]').get();
        if (childrenWithAttributes.length) {
            for (var _i = 0, childrenWithAttributes_1 = childrenWithAttributes; _i < childrenWithAttributes_1.length; _i++) {
                var child = childrenWithAttributes_1[_i];
                var attribute = child.getAttribute('data-get');
                if (attribute === 'displayAdress') {
                    var city = ((_a = studio === null || studio === void 0 ? void 0 : studio.address) === null || _a === void 0 ? void 0 : _a.city) || '';
                    if (city.length && ((_b = studio === null || studio === void 0 ? void 0 : studio.address) === null || _b === void 0 ? void 0 : _b.zipCode)) {
                        city = studio.address.zipCode + ' ' + city;
                    }
                    var street = ((_c = studio === null || studio === void 0 ? void 0 : studio.address) === null || _c === void 0 ? void 0 : _c.street) || '';
                    if (street === null || street === void 0 ? void 0 : street.length) {
                        if ((_d = studio === null || studio === void 0 ? void 0 : studio.address) === null || _d === void 0 ? void 0 : _d.houseNumber) {
                            street += ' ' + ((_e = studio === null || studio === void 0 ? void 0 : studio.address) === null || _e === void 0 ? void 0 : _e.houseNumber);
                        }
                        if (city === null || city === void 0 ? void 0 : city.length) {
                            street += ', ';
                        }
                    }
                    child.innerHTML = street + city;
                }
                else if (attribute === 'distanceToUser') {
                    if (studio === null || studio === void 0 ? void 0 : studio.distanceToUser) {
                        child.innerHTML = studio.distanceToUser + 'km';
                        child.style.display = null;
                    }
                    else if (((_g = (_f = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _f === void 0 ? void 0 : _f.distanceToUserErrorMessage) === null || _g === void 0 ? void 0 : _g.length) &&
                        +((_h = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.location) === null || _h === void 0 ? void 0 : _h.distanceToUserErrorMessage) > 0) {
                        child.innerHTML = variables_const_1._settings.location.distanceToUserErrorMessage;
                        child.style.display = null;
                    }
                    else {
                        child.style.display = 'none';
                    }
                }
                else if (attribute === 'studioImageUrl') {
                    child.src = studio[attribute];
                }
                else if ((0, get_1.default)(studio, attribute)) {
                    var html = (0, get_1.default)(studio, attribute);
                    if (typeof html === 'object') {
                        console.info('Your data-get path ends in an [object object]', attribute, ' thats the object: ', Object.keys(html), 'maybe you wanna try: "' +
                            attribute +
                            Object.keys(html)[0] +
                            '" for data-get');
                    }
                    child.innerHTML = html;
                }
                else {
                    console.error('your data-get path ', attribute, ' doesnt exist in object');
                }
            }
        }
        else {
            console.error('You didnt specifiy any data-get attributes inside your refobject');
        }
    };
    Location.prototype.showMore = function () {
        this.maxShowedStudios += 3;
        this.filterStudiosByDistance();
    };
    Location.prototype.addStyle = function () {
        if (this.stylesAdded === false) {
            $('<style>')
                .prop('type', 'text/css')
                .html("\n            .default-loc-box, .location-picker, .search-result-picker{\n                display: flex;\n                min-height: 75px;\n                align-items: center;\n                justify-content: space-between;\n                padding: 20px;\n                box-shadow: 0px 0px 4px #666;\n                margin-bottom: 25px;\n                cursor: pointer;\n            }\n            .show-more-button-css{\n              text-align:center;\n              background: #fff;\n              justify-content: center !important;\n              color: #111;\n            }\n            #search-results-wrapper{\n              display: flex;\n              flex-direction: column;\n              justify-content: center;\n              align-items: center;\n            }\n        ")
                .appendTo('head');
            this.stylesAdded = true;
        }
    };
    return Location;
}());
exports.Location = Location;
